<template>
  <v-content>
    <v-row no-gutters>
      <v-col cols="12">
        <v-flex class="pb-2 ml-0">
          <v-alert dense color="primary" class="text-left" text border="left"
            >TAXA ENTREGA DISTÂNCIA</v-alert
          >
        </v-flex>
      </v-col>
    </v-row>

    <v-card v-show="!sv">
      <v-row no-gutters>
        <v-col cols="4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Pesquisar"
            filled
            dense
            single-line
            hide-details
          ></v-text-field>
        </v-col>
        <v-col class="text-left" cols="4">
          <v-btn
            @click="novo()"
            v-show="$can('taxa_entrega.create|admin.loja')"
            color="topEnviados"
            dark
          >
            <v-icon>mdi-plus</v-icon>Nova
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="itemsCategoria"
        :loading="loading_table"
        :footerProps="footerProps"
        loading-text="Carregando... Aguarde"
        dense
        :search="search"
        no-data-text="Nenhum resultado encontrado!"
        no-results-text="Nenhum resultado encontrado!"
        class="elevation-2"
      >
        <!--<template class="text-right" v-slot:item.chk_ativo="{ item }">
          <v-switch
            class="text-rigth"
            color="botao_sucesso"
            :label="`${checkStatus(item.chk_ativo)}`"
            @change="mudarStatus(item.id, item.chk_ativo)"
            v-model="item.chk_ativo == 1 ? true : false"
            value="item.chk_ativo"
          ></v-switch>
        </template>-->
        <template v-slot:item.action="{ item }">
          <v-icon class="mr-2" color="error" @click="excluirTaxa(item)"
            >delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogCancel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cancelamento</v-card-title>
          <v-card-text>Deseja excluir essa taxa?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              class="white--text"
              @click="dialogCancel = false"
              >Não</v-btn
            >
            <v-btn
              color="green darken-1"
              class="white--text"
              @click="deleta(selItem)"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialogCadastro" persistent max-width="50%">
      <v-card>
        <v-card-title class>Cadastro Taxa Entrega  Distância</v-card-title>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="taxa.km_inicial"
                  label="km inicial"
                  v-currency="{
              currency: 1,
              locale: 'en',
              precision: 1,
              prefix:'Km'
            }"
                  filled                  
                  dense                  
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="taxa.km_final"
                  label="km final"
                  v-currency="{
              currency: 1,
              locale: 'en',
              precision: 1,
              prefix:'Km'
            }"
                  filled                  
                  dense                  
                  clearable
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="4" md="4" lg="4">
                <v-text-field
                  v-model="taxa.vlr_taxa"
                  prepend-inner-icon="monetization_on"
                  label="Taxa"
                  v-currency="{
                    currency: null,
                    locale: 'pt-PT',
                    precision: 2,
                  }"
                  filled
                  dense
                
                  clearable
                  required
                ></v-text-field>
              </v-col>
              
            </v-row>
           
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="error" @click="dialogCadastro = false">
              <v-icon>mdi-close</v-icon>Fechar
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-btn color="success" @click="gravar()" class="mr-4">
              <v-icon>mdi-check</v-icon>Gravar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
      <v-snackbar
      :timeout="tempo"
      :color="error"
      :multi-line="multiline"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      {{ textSnack }}
      <v-btn text @click.native="snackbar = false">x</v-btn>
    </v-snackbar>
    </v-dialog>
   
    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      {{ textSucesso }}
      <v-btn @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>
  </v-content>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    source: String,
  },
  data: () => ({
    singleLine: true,
    footerProps: { "items-per-page-options": [30, 50, 100] },
    categoria: {
      descricao: "",
    },
    botao_sucesso: "botao_sucesso",
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false /* doesn't work with directive */,
    },
    error: "error",
    tempo: 5000,
    mode: "vertical",
    snackbar: false,
    textSnack: "",
    multiline: true,
    sucesso: "botao_sucesso",
    snackbarSuccess: false,

    textSucesso: "",

    cep: "",
    sheet: false,

    itemsUnidade: ["UN", "PC", "KG"],

    filtroProduto: "Produtos ",
    sv: false,
    carregaCep: false,
    dialogCadastro: false,
    itensPorPagina: 25,
    itemsCategoria: [],
    itemsProdutosSgt: [],
    itemsProdutosSgtVinculados: [],
    search: "",
    searchVinculados: "",
    loading_table: false,
    selProduto: "",
    itemEdit: "",
    dialogCancel: false,
    selItem: "",

    taxa: { km_inicial: "", km_final: "", vlr_taxa:0 },
    headers: [
      {
        text: "Km Inicial",
        align: "left",
        sortable: true,
        value: "km_inicial",
      },
      {
        text: "Km Final",
        align: "left",
        sortable: true,
        value: "km_final",
      },
      {
        text: "Taxa",
        value: "vlr_taxa",
        sortable: true,
        align: "right",
      },
      /* {
        text: "Status",
        value: "chk_ativo",
        sortable: true,
        align: "left",
      },*/
      { text: "Ação", value: "action", sortable: false },
    ],
  }),
  watch: {
    cep(val) {
      if (this.cep.length == 8) {
        this.carregaCep = true;
        this.buscaCep(val);
        ///this.mensagem.tipo.splice(a, 1);
        event.preventDefault();
      }
    },
    sv(val) {
      if (val === true) {
        this.filtroProduto = "Produtos vinculados";
        this.buscaProdutosSgtVinc();
      } else {
        this.filtroProduto = "Produtos sem Vinculo";
      }
    },
  },
  mounted() {
    //this.buscaProdutos();

    this.buscaTaxas();
  },
  methods: {
    checkStatus(valor) {
      if (valor == 1) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    buscaCep(cep) {
      this.$viaCep.buscarCep(cep).then((obj) => {
        if (obj.erro) {
          this.cep = "";
          this.textSnack = "Cep não existe!";
          this.snackbar = true;

          this.carregaCep = false;
        } else {
          this.carregaCep = false;
          this.taxa.localidade = obj.localidade;
          this.taxa.logradouro = obj.logradouro;
          this.taxa.uf = obj.uf;
          this.taxa.bairro = obj.bairro;
        }
      });
    },
    limpaCampos() {
      this.taxa.km_inicial = "";
      this.taxa.km_final = "";     
      this.taxa.vlr_taxa = "0,00";
    
    },
    novo() {
      this.dialogCadastro = true;
      this.limpaCampos();
    },
    excluirTaxa(item) {
      this.selItem = item.id;
      this.dialogCancel = true;
    },
    deleta() {
      axios.post(`/taxa/delete_distancia`, { id: this.selItem }).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.buscaTaxas();
          this.itemEdit = "";
          this.dialogCancel = false;
          this.selProduto = "";
        }
      });
    },
    editProduto(item) {
      this.dialog = true;
      this.itemEdit = item.id;
    },
    buscaTaxas() {
      this.loading_table = true;
      axios.get(`/taxa/taxas_distancia`).then((response) => {
        if (response.data.error) {
          //  this.textSnack = response.data.error;
          //  this.snackbar = true;
        } else {
          this.loading_table = false;
          this.itemsCategoria = response.data;
        }
      });
    },
    gravar() {
      axios
        .post(`/taxa/taxa_distancia`, this.taxa)
        .then((response) => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.snackbarSuccess = true;
            this.textSucesso = "Taxa incluida com sucesso!";
            this.buscaTaxas();
            this.itemEdit = "";
            this.selProduto = "";
            this.limpaCampos();
          }
        })
        .catch((e) => {
          if (!Array.isArray(e.response.data)) {
            let itens = [];
            for (var prop in e.response.data) {
              itens.push(e.response.data[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.error;
            this.snackbar = true;
          }
        });
    },

    buscaProdutosSgtVinc() {
      axios
        .post(`/produtos/semgtin_vinc/lista`, {
          id_cliente: window.sessionStorage.getItem("cnpj"),
        })
        .then((response) => {
          if (response.data.error) {
            //  this.textSnack = response.data.error;
            //  this.snackbar = true;
          } else {
            // this.loading_table = false;
            //this.loading_filtrar = false;
            this.itemsProdutosSgtVinculados = response.data;
          }
        });
    },
  },
};
</script>
<style scoped>
.v-input--selection-controls {
  padding: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.v-data-table td {
  font-size: 0.685rem !important;
}

.v-messages {
  min-height: 0px !important;
}
</style>
